import { USERNAME } from 'mk2/helpers/api';

export const settings = '/settingsapp/';

export const settingsPhone = `/settingsapp/${USERNAME}/phone/`;
export const settingsSignup = `/settingsapp/signup/`;

export const settingsProfile = `/settingsapp/${USERNAME}/profile/`;

export const settingsKids = `/settingsapp/${USERNAME}/kids/`;
export const settingsKidAdd = `/settingsapp/${USERNAME}/kid/add/:sex(boy|girl)/`;
export const settingsKidEdit = `/settingsapp/${USERNAME}/kid/edit/:kidId/`;

export const settingsAccount = `/settingsapp/${USERNAME}/account/`;
